export class NumberUtils {
	/*https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/
	toLocaleString#Checking_for_support_for_locales_and_options_arguments*/
	private static toLocaleStringSupportsOptions: boolean =
		!!(typeof Intl == "object" && Intl && typeof Intl.NumberFormat == "function");
	/**
	 * Separador default configurado no cliente.
	 */
	public static readonly decimalSeparator: string = 1.1.toLocaleString().substring(1, 2);

	public static round(num: number, digits: number) {
		let d = Math.pow(10, digits);
		return Math.round(num * d) / d;
	}

	public static toCurrencyLocale(num: number): string {
		return this.toFixedLocale(num, 2);
	}

	public static toFixedLocale(num: number, casas:number): string {
		if (this.toLocaleStringSupportsOptions) {
			return num.toLocaleString(undefined,
				{ minimumFractionDigits: casas, maximumFractionDigits: casas });
		}
		return num.toFixed(2).replace(".", this.decimalSeparator);
	}

	public static parseLocale(num: string): number {
		return Number.parseFloat(num.replace(this.decimalSeparator, "."));
	}

	/** min e max servem só pra validar o length */
	public static getMaskConfig(min = 0, max = Number.MAX_SAFE_INTEGER, decimals = 2): any {
		let textMaskConfig: any = {};
		textMaskConfig.guide = false;
		textMaskConfig.mask = <any>((num: string): (string|RegExp)[] => {
			const regex: (string|RegExp)[]  = [];

			let negativeSignDisplacement = 0;

			if (num[0] == "-" && min < 0) { // começo com sinal negativo
				negativeSignDisplacement = 1;
				regex.push(new RegExp("^-"));
			}

			const maxLength = Math.trunc(Math.log(max) * Math.LOG10E) + 1;
			const len = Math.min(num.length, maxLength + negativeSignDisplacement);

			for (let i = negativeSignDisplacement; i != len; i++) {
				if (num[i] == NumberUtils.decimalSeparator) {
					break;
				}
				regex.push(/\d/);
			}

			if (num.indexOf(NumberUtils.decimalSeparator) != -1) {
				regex.push("[]", NumberUtils.decimalSeparator, "[]");

				// decimais
				for (let i = decimals; i--; ) {
					regex.push(/\d/);
				}
			}

			return regex;
		});

		return textMaskConfig;
	}
}